
import React, {useState} from "react";
import { Button, Form } from "react-bootstrap";
import doller from "../../../assets/images/game/doller.svg"
import refresh from "../../../assets/images/game/refresh.svg"
import cross from "../../../assets/images/game/cross.svg"
import percent from "../../../assets/images/game/percent.svg"
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css"

const ManualGame = () => {

    const [range, setRange] =  useState(50)
    const [range1, setRange1] =  useState(10)


    
    return(
        <div className="manual-game">

            <Form>

               <div className="bet-box">
                <Form.Group>
                    <Form.Label>Bet Amount</Form.Label>
                    <div className="bet-input pdd-200">
                        <img src={doller} alt="" />
                        <Form.Control type="number" placeholder="58.52" />
                        <div className="bet-input-btn">
                            <Button>1/2</Button>           
                            <Button>2x</Button>           
                            <Button>Max</Button>
                        </div>
                    </div>
                </Form.Group>

                <Form.Group>
                    <Form.Label>Payout On Win</Form.Label>
                    <div className="bet-input">
                        <img src={doller} alt="" />
                        <Form.Control type="number" placeholder="58.52" />
                    </div>
                </Form.Group>

                </div>

                <div className="payout-box">

                        <Form.Group>
                            <Form.Label>Roll Under</Form.Label>
                            <div className="bet-input">
                                <img src={refresh} alt="" />
                                <Form.Control type="number" placeholder="58.52" />
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Multiplier</Form.Label>
                            <div className="bet-input">
                                <img src={cross} alt="" />
                                <Form.Control type="number" placeholder="58.52" />
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Win Chance</Form.Label>
                            <div className="bet-input">
                                <img src={percent} alt="" />
                                <Form.Control type="number" placeholder="58.52" />
                            </div>
                        </Form.Group>

                </div>


                <div className="roll-dice">
                    <Button>ROLL DICE</Button>
                </div>




                <div className="roll-slider dice-slider">
                    <div className="result-dice">
                    <InputRange
                    maxValue={100}
                    minValue={0}
                    value={range1}
                    onChange={value => setRange1(value)} /> 
                    </div>
                    <InputRange
                    maxValue={100}
                    minValue={0}
                    value={range}
                    onChange={value => setRange(value)} />
                </div>

        

            </Form>


        </div>


);
};

export default ManualGame;